<template>
    <el-table
      :data="data"
      stripe
      :dynamicOperationName="dynamicOperationName"
      @selection-change="handleSelectionChange"
      :row-key="getRowKeys"
      :cell-class-name="cellClassName"
      ref="multipleTable"
      :height="autoheight"
      :max-height="autoheight"
      style="width: 100%">
          <div slot="empty" >
            <div>
              <img src="../../../../static/image/defaultpic.png" alt=""  height="140" />
            </div>
            <!-- <p :style="{'marginTop': '23px'}">暂无数据</p> -->
          </div>

      <el-table-column v-if="dynamicOperationName==='entryPage'"
        type="index"
        label="序号"
        width="50">
      </el-table-column>
      <el-table-column
        type="selection"
        width="26"
        v-if="showCheck"
        :reserve-selection="resSelection">
      </el-table-column>

      <el-table-column
        v-if="isCamera"
        :label="withCameraData.label"
        :min-width="withCameraData.width">
        <template slot-scope="scope">
          <div style="width:100%">
            <span>{{ scope.row[withCameraData.props] }}</span>
            <i v-if="scope.row.havaVide && scope.row.havaVide !== '0'"  style="float: right; right:10px;margin-top: 5px;" class="icon-shexiangji"></i>
          </div>
        </template>
      </el-table-column>

      <el-table-column v-for="item in head"
                       :key="item.label"
                       :show-overflow-tooltip="show"
                       :prop="item.props"
                       :label="item.label"

                       :min-width="item.width">
      </el-table-column>
      <!-- <el-table-column v-if="dynamicOperationName==='entryPage'"
                       width="80"
                       type="index"
                       label="会议状态">
        <template slot-scope="scope">
          <div v-if='scope.row.state==1' class="beginning">进行中</div>
          <div v-else-if='scope.row.state==0' class="nobegin">未进行</div>
        </template>
      </el-table-column> -->

      <el-table-column
        type="index"
        label="操作"
        :width="operationWidth">
        <template slot-scope="scope">
          <el-button v-if="dynamicOperationName === 'teacher'" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="(item,index) in operation"
                     type="text"
                     :key="item.class"
                     :class="
                     (index==1?
                          (scope.row.onShelf!=='已上架' && scope.row.courseState !=='已结束' && scope.row.courseState !=='进行中'&& scope.row.courseState =='未开始' || scope.row.courseState =='未上架' || scope.row.courseState ==' ' ? item.class:item.class2):
                     (index==2?
                          (scope.row.onShelf=='已上架' ? item.class:item.class2):
                     (index==3?
                          (scope.row.onShelf=='未上架' ? item.class:item.class2):
                          item.class)
                      ))" class="iconfont" size="big" :title="item.title">
          </el-button>
          <el-button v-if="dynamicOperationName === 'manageMeeting'" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="(item,index) in operation"
                     type="text"
                     :key="item.class"
                     :class="
                     (index==1?
                          (scope.row.sendState=='保存待发' ? item.class:item.class2):
                     (index==2?
                          ((scope.row.sendState=='已发送' && scope.row.status=='进行中') || (scope.row.sendState=='已发送' && scope.row.status=='未开始')? item.class:item.class2):
                     (index==3?
                          (scope.row.sendState=='已发送' && scope.row.status=='未开始' && scope.row.confChairName == confChairName ? item.class:item.class2):
                          item.class)
                      ))" class="iconfont" size="big" :title="item.title">
          </el-button>
          <el-button v-if="dynamicOperationName === 'entryPage'" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="(item,index) in operation"
                     type="text"
                     :key="index"
                     :class="(scope.row.sendState==1 && scope.row.statusName=='进行中') || (scope.row.sendState==1 && scope.row.statusName=='未开始')? item.class:item.class2" class="iconfont" size="big" :title="item.title">
          </el-button>
          <el-button v-if="dynamicOperationName === ''" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="item in operation"
                     type="text"
                     :key="item.class"
                     :class="item.class" class="iconfont" size="big" ><span class="hover_title" :title="item.name">{{item.name}}</span>
          </el-button>
          <el-button v-if="dynamicOperationName === 'operate'" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="(item,index) in operation"
                     type="text"
                     :key="item.class"
                     :class="(index==0?(scope.row.reportState=='3' ? item.class:item.class2):(index==3 ? (scope.row.readFilmFlag !='1' ? item.class : item.class2):item.class)) " class="iconfont" size="big" :title="item.title">{{item.operation}}
            <!--item.readFilmFlag ==0 ? item.class : item.class2-->
          </el-button>
          <el-button v-if="dynamicOperationName === 'courseWare'&& scope.row.creator !== UserId" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="item in operationPrivate"
                     type="text"
                     :key="item.class"
                     :class="item.class" class="iconfont Private" size="big" ><span class="hover_title" :title="item.name">{{item.name}}</span>
          </el-button>
          <el-button v-if="dynamicOperationName === 'courseWare'&& scope.row.creator === UserId" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="item in operationOpen"
                     type="text"
                     :key="item.class"
                     :class="item.class" class="iconfont" size="big" ><span class="hover_title" :title="item.name">{{item.name}}</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

</template>

<script type="text/ecmascript-6">
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import * as _ from '@/common/js/config'
  import http from '@/api/http'
  export default {
    props: {
      isCamera:{
        type: Boolean,
        default: false,
      },
      withCameraData:{
        props:"",
        label:"",
        width:"12%"
      },
      showCheck:{
        type: Boolean,
        default: false,
      },
      data: {
        type: Array,
        default: function () {
          return []
        }
      },
      head: {
        type: Array,
        default: () => []
      },
      operation: {
        type: Array,
        default: () => []
      },
      operationWidth: {
        type: String,
        default: '130'
      },
      dynamicOperationName: {
        type: String,
        default: ''
      },
      cellClassName:{
        type:Function,
        default:  function ({row, rowIndex,column,columnIndex}) {
          return ''
        }
      },
      autoheight: {
        type: [String, Number],
        default: 300
      },
      width:{
        type: String,
        default: ''
      },
      studyList: {
        type: Array,
        default: () => []
      },
      resSelection:{
        type:Boolean,
        default:true
      }
    },
    computed: {},
    watch: {
      oldList(c, o) {
        this.$nextTick(() => {
          this.data.forEach(row => {
            for (let item of c) {
              if (item.id === row.id) {
                this.$refs.multipleTable.toggleRowSelection(row, true)
              }
            }
          });
        })
      },
      studyList(c, o) {
        this.aOldResult = o
      }
    },
    created() {
      this.oldList = this.studyList
    },
    mounted() {

      //先从local storage中获取
      if( localStorage.getItem("userInfoData")){
        const userInfoData =JSON.parse(localStorage.getItem("userInfoData"));
        this.confChairName = userInfoData.userName
        this.UserId = userInfoData.userId
      }else{
        this.getUserInfo();
      }
      // console.log(this.confChairName)
    },
    methods: {
      getUserInfo(){
        //登录用户信息
        http.post('/getUserInfo.json').then(res => {
          if (res.data.code === _.ERR_OK) {
          this.confChairName = res.data.model.userName
          this.UserId = res.data.model.userId
          }
        }).catch(() => {

        })
      },
      _operation(row, operation,index) {
        let payload = Object.assign(row, {
          operation,
          index
        })
        this.$emit('_operation', payload)
      },
      // getH() {
      //   if(document.getElementsByClassName('epTable')[0]!==undefined){
      //     this.autoheight = document.getElementsByClassName('epTable')[0].clientHeight
      //   }
      //   let innerH = document.getElementsByClassName('left')[0].clientHeight
      //   let crumbs = document.getElementsByClassName('crumbs')[0].clientHeight
      //   let search
      //   if(document.getElementsByClassName('search')[0]===undefined){
      //     search = 56
      //   } else {
      //     search = document.getElementsByClassName('search')[0].clientHeight +40
      //   }
      //   if(this.showCheck) {
      //     this.autoheight = innerH - crumbs - search - 125
      //   } else {
      //     this.autoheight = innerH - crumbs - search - 102
      //   }
      // },
      handleSelectionChange(val){
        // 表格选中事件
        this.oldList = val
      },
      getList(){
        this.$emit('selection',this.oldList)
      },
      clearList(){
        this.$refs.multipleTable.clearSelection()
      }
    },
    data() {
      return {
        oldList: [],
        show: true,
        UserId: '',
        confChairName: '',
        operationOpen: [
          {
            name: '查看',
            operation: '',
            class: 'icon-chakan'
          },
          {
            name: '修改',
            operation: '',
            class: 'icon-bianji'
          },
          {
            name: '删除',
            operation: '',
            class: 'icon-shanchu'
          }
        ],
        operationPrivate: [
          {
            name: '查看',
            operation: '',
            class: 'icon-chakan'
          },
          {
            name: '修改',
            operation: '',
            class: 'icon-bianji hui'
          },
          {
            name: '删除',
            operation: '',
            class: 'icon-shanchu hui'
          }
        ],
        getRowKeys(row) {
          return row.id;
        },
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable.styl'
  .hover_title
    display: inline-block
    width: 19px
    height: 19px
    opacity: 0
    margin-left: -19px

</style>



// WEBPACK FOOTER //
// publicTable.vue?5962b462